package kangaroorewards.appsdk.core.network.base

/**
 * Query class used to build requests
 */
data class Query(
    val name: String,
    val value: Any?
)